import React from 'react';
import Styled from 'styled';

import defaultStyles, { ILastLoginScss } from './last-login.scss';
import { LastLoginFragment } from './last-login.graphql';
import { FormattedMessage, intlShape, InjectedIntl } from 'react-intl';

export interface Props extends LastLoginFragment {
    styles?: ILastLoginScss;
}

interface State {
    lastLogin?: Date;
    now: Date;
    daysBetweenLastLogin?: number;
}

const DAY_IN_MILISECONDS = 8.64e7;
const ONE_MINUTE = 60 * 1000;

interface Context {
    intl: InjectedIntl;
}

class LastLogin extends React.PureComponent<Props, State> {
    static contextTypes = {
        intl: intlShape,
    };

    context!: Context;

    interval?: NodeJS.Timer;

    constructor(props: Props, context: Context) {
        super(props, context);

        const lastLogin = this.props.lastLogin ? new Date(this.props.lastLogin) : undefined;
        const now = new Date(this.context.intl.now());

        this.state = {
            now,
            lastLogin,
            daysBetweenLastLogin: this.daysBetweenLastLogin(now, lastLogin),
        };
    }

    daysBetweenLastLogin(now?: Date, lastLogin?: Date) {
        return now && lastLogin
            ? Math.round(Math.abs(now.getTime() - lastLogin.getTime()) / DAY_IN_MILISECONDS)
            : undefined;
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState({
                now: new Date(),
            });
        }, ONE_MINUTE);
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.lastLogin !== this.props.lastLogin || prevState.now !== this.state.now) {
            const lastLogin = this.props.lastLogin ? new Date(this.props.lastLogin) : undefined;

            this.setState({
                lastLogin,
                daysBetweenLastLogin: this.daysBetweenLastLogin(this.state.now, lastLogin),
            });
        }
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const { styles } = this.props;
        const { daysBetweenLastLogin } = this.state;

        if (daysBetweenLastLogin != null) {
            const active = daysBetweenLastLogin <= 14;

            return (
                <React.Fragment>
                    {active ? (
                        <FormattedMessage id='ACTIVE_USER'>
                            {msg => <span className={styles!.active}>{msg}</span>}
                        </FormattedMessage>
                    ) : (
                        <FormattedMessage id='INACTIVE_USER'>
                            {msg => <span className={styles!.inactive}>{msg}</span>}
                        </FormattedMessage>
                    )}
                    {daysBetweenLastLogin <= 14 ? (
                        <span className={styles!.description}>
                            {daysBetweenLastLogin <= 7 ? (
                                <FormattedMessage id='IN_LAST_7_DAYS' />
                            ) : (
                                <FormattedMessage id='IN_LAST_14_DAYS' />
                            )}
                        </span>
                    ) : null}
                </React.Fragment>
            );
        }

        return null;
    }
}

export default Styled(defaultStyles)(LastLogin);
